import { VStack, Text } from '@chakra-ui/react';
import MfaEnterCode from './MfaEnterCode';

function MfaSetUpEmail({ onComplete, isModal = null }) {
  return (
    <VStack spacing={6} alignItems="flex-start" my={6}>
      <VStack mb={4} alignItems="flex-start">
        <Text textStyle="heading4">Check your inbox</Text>
        <Text textStyle="bodySmall" color="#666666">
          We've sent a one-time code to your email address.
          <br />
          Open your inbox and enter the code to finish setting up two-step
          verification.
        </Text>
      </VStack>
      <MfaEnterCode isEmail={true} onSuccess={onComplete} isModal={isModal} />
    </VStack>
  );
}

export default MfaSetUpEmail;
